import { TPaymentStatusDataInfo } from '../PaymentStatusMessage/types/IPaymentStatusInfo'

export const paymentInfoObject: TPaymentStatusDataInfo = {
  canceled: {
    message: 'This appointment has been cancelled.',
    icon: 'circle-minus',
  },
  expired: {
    message: 'This appointment has expired.',
    icon: 'circle-exclamation',
  },
  failed: {
    message: 'This appointment has failed to proceed.',
    icon: 'circle-x',
  },
  paid: {
    message: 'This appointment has been successfully paid.',
    icon: 'circle-dollar',
  },
  collected: {
    message: 'This appointment has been confirmed.',
    icon: 'circle-check',
  },
  requested: {
    message: 'The appointment payment is pending.',
    icon: 'circle-ellipsis',
  },
}
